// Toggle button to pause logo wall animation
import Component from '../../Component';

class LogoWallButton extends Component {
	static selector = '.header-logo-wall';

	static children = {
		button: '.header-logo-wall__button',
	};

	// Defines event handlers to attach to children
	eventHandlers = {
		button: {
			click: this.onButtonClick,
		},
	};

	constructor(element: HTMLElement) {
		super(element);
		this.classNamePaused = 'is-paused';
	}

	onButtonClick(e: Event & { currentTarget: HTMLElement }) {
		this.element.classList.toggle(this.classNamePaused);
	}
}

LogoWallButton.init();

export default LogoWallButton;
